var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInspireThroughValues(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 83,
    viewBox: "0 0 85 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e68242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#e1613a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd4633"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 85,
    height: 83,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspireThroughValues);
export default __webpack_public_path__ + "static/media/inspire_through_values.10e5756e32f2217f5339c5d7d31fad52.svg";
export { ForwardRef as ReactComponent };